const ITEMS = [
  "Trauma-informed care",
  "Individuals",
  "Couples",
  "Families",
  "Veterans & defence families",
  "NDIS behaviour support",
  "Family law assessment",
  "Gold Coast · Canberra",
];

const Leaf = () => (
  <svg viewBox="0 0 24 24" className="mx-8 h-3.5 w-3.5 shrink-0 text-euca-sage" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
    <path d="M12 21 C12 14 12 8 13 3" />
    <path d="M12 15 Q7.5 14 5.5 10 Q10 11 12 15 Z" />
    <path d="M12.2 11.5 Q17 10.5 19 7 Q14.5 8 12.2 11.5 Z" />
  </svg>
);

export default function Marquee() {
  const row = (
    <div className="flex items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center whitespace-nowrap">
          <span className="font-serif text-lg italic text-euca-dark/70">{item}</span>
          <Leaf />
        </span>
      ))}
    </div>
  );
  return (
    <div className="overflow-hidden border-y border-euca-line bg-white py-5" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track">
        {row}
        {row}
      </div>
    </div>
  );
}
